
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/select-service",
      function () {
        return require("private-next-pages/select-service/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/select-service"])
      });
    }
  